import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Step12 } from '../../../../shared/models/component-messages/mapaIN/step12';
import { TypeRensA } from '../models/TypeRensA';
import { CTRL_268 } from '../../../validators/268/ctrl268';
import { AutoCompleteService } from '../../../../shared/services/auto-complete.service';
import { AvisDataTransferService } from '../../../../shared/services/avis-data-transfer.service';
import { TypeAdresseComplete } from '../models/TypeAdresseComplete';
import { TypeAnnexeATA } from '../models/TypeAnnexeATA';
import { Envoi } from '../models/Envoi';
import { RensComplementaires } from '../models/RensComplementaires';
@Component({
  selector: 'app-type-rensA',
  templateUrl: './type-rensA.component.html'
})
export class TypeRensAComponent implements OnInit, AfterViewInit {

  @Input() uid = '';
  public current_uid = 'TypeRensA';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;

	@Input() adressesComplt: TypeRensA;
  public rg1 = CTRL_268.id + '_5';
  public rg2 = CTRL_268.id + '_6';
  public rg3 = CTRL_268.id + '_7';
  public rg4 = CTRL_268.id + '_8';
  isAdmEtTech: boolean;
  isAdmOuTech: boolean;
  isDocument: boolean;
  isEnvoi: boolean;
  isRensComplementaires: boolean;

  selected;


  public optionsSelect: any[];
  public optionsSelectType = 'TYPERENS';

  public step12 = new Step12();

  constructor(private autoCompleteService: AutoCompleteService, private avisDataTransferService: AvisDataTransferService) { }

  public ngOnInit() {
    this.optionsSelect = this.autoCompleteService.getOptions(this.optionsSelectType);
    this.admEtTech();
    this.admOuTech();
    this.document();
    this.envoi();
    this.rensComplementaires();
  }

  ngAfterViewInit() {
    this.researchFormOnChangeDetecte();
  }

  researchFormOnChangeDetecte(){
    const controlName = this.getUid() + '_SepAtt_typerensaSelect';
    const control = this.parentForm.get(controlName);
    if (control) {
      control.valueChanges.subscribe(value => {
        this.admEtTech();
        this.admOuTech();
        this.document();
        this.envoi();
        this.rensComplementaires();
      });
    }
  }

  getSelect() {
    return this.parentForm.controls[this.getUid() + '_SepAtt_typerensaSelect'] ?
                        this.parentForm.controls[this.getUid() + '_SepAtt_typerensaSelect'].value :
                        this.avisDataTransferService.getFormData().jsonSaisieFormulaire.ann.mapa.initialFromMAPA.adressesComplt.typeRensSelect;
     
  }

  admEtTech(){
    this.isAdmEtTech = this.getSelect() === 'admEtTech';
    if (this.isAdmEtTech) {
      if (!this.adressesComplt.admEtTech)
        this.adressesComplt.admEtTech = new TypeAdresseComplete();
      this.parentForm.addControl(this.getStepId() + this.rg1, new FormControl({ rgCtrls: this.getCtrl_268_1Names_json() }));
    }
  }

  admOuTech(){
		this.isAdmOuTech = (this.getSelect() === 'tech') || (this.getSelect() === 'adm') ;
    if (!this.adressesComplt.admOuTech)
      this.adressesComplt.admOuTech = new TypeAnnexeATA();
  }

  document(){
    this.isDocument = this.getSelect() === 'document';
    if (this.isDocument) {
      if (!this.adressesComplt.document)
        this.adressesComplt.document = new TypeAdresseComplete();
      this.parentForm.addControl(this.getStepId() + this.rg2, new FormControl({ rgCtrls: this.getCtrl_268_2Names_json() }));
    }
  }

  envoi(){
    this.isEnvoi = this.getSelect() === 'envoi';
    if (this.isEnvoi) {
      if (!this.adressesComplt.envoi)
        this.adressesComplt.envoi = new Envoi();
      this.parentForm.addControl(this.getStepId() + this.rg3, new FormControl({ rgCtrls: this.getCtrl_268_3Names_json() }));
    }
  }

  rensComplementaires(){
    this.isRensComplementaires = this.getSelect() === 'rensComplementaires';
    if (this.isRensComplementaires) {
      if (!this.adressesComplt.rensComplementaires)
        this.adressesComplt.rensComplementaires = new RensComplementaires();
      this.parentForm.addControl(this.getStepId() + this.rg4, new FormControl({ rgCtrls: this.getCtrl_268_4Names_json() }));
    }
  }

  admOuTechSelect(){
    if (this.getSelect() === 'tech') {
      return 'tech';
    } else if (this.getSelect() === 'adm') {
      return 'adm';
    }
  }



  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

  getStepId() {
    return this.uid.substring(0, this.uid.indexOf("SepSep"));
  }

  private getCtrl_268_1Names_json(): any {
    const deptPub = '_SepSep_TypeIndexation_SepSep_TypeDept_SepAtt_deptPub';
    const cp = 'admEtTech_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepAtt_cp';
    return { firstChamp: deptPub, secondChamp: cp };
  }

  private getCtrl_268_2Names_json(): any {
    const deptPub = '_SepSep_TypeIndexation_SepSep_TypeDept_SepAtt_deptPub';
    const cp = 'document_SepSep_Initial_SepSep_TypeRensA_SepSep_TypeAdresseComplete_SepSep_TypeAdresse_SepAtt_cp';
    return { firstChamp: deptPub, secondChamp: cp };
  }

  private getCtrl_268_3Names_json(): any {
    const deptPub = '_SepSep_TypeIndexation_SepSep_TypeDept_SepAtt_deptPub';
    const cp = '_SepSep_Initial_SepSep_TypeRensA_SepSep_Envoi_SepSep_TypeAdresse_SepAtt_cp';
    return { firstChamp: deptPub, secondChamp: cp };
  }

  private getCtrl_268_4Names_json(): any {
    const deptPub = '_SepSep_TypeIndexation_SepSep_TypeDept_SepAtt_deptPub';
    const cp = '_SepSep_Initial_SepSep_TypeRensA_SepSep_RensComplementaires_SepSep_TypeAdresse_SepAtt_cp';
    return { firstChamp: deptPub, secondChamp: cp };
  }


}

